/**
 * Builds a querystring to carry widget filter state through to /contracts.
 *
 * Every caller is responsible for naming their own params so there's no
 * ambiguity between e.g. acceptedStartDate vs disbursedStartDate.
 *
 * Usage:
 *   buildContractsQuery({ status: "Accepted" })
 *   buildContractsQuery({ status: "Accepted", acceptedStartDate: "2024-01-01", acceptedEndDate: "2024-06-30" })
 *   buildContractsQuery({ notationText: "Failure to collect payment" })
 *
 * @param {object} params  flat key/value pairs
 * @returns {string} URL-encoded querystring without leading `?`
 */
export function buildContractsQuery(params = {}) {
  const search = new URLSearchParams();

  Object.entries(params).forEach(([k, v]) => {
    if (v == null || v === "") return;
    if (Array.isArray(v)) {
      if (v.length > 0) search.set(k, v.join(","));
    } else {
      search.set(k, String(v));
    }
  });

  return search.toString();
}
